<template>
    <div id="transfers-page" class="gradbg">
        <div class="header-panel">
            <h1>Set Up Automatic Transfers</h1>
        </div>
        <form @submit.prevent="setupTransfers">
            <div class="field">
                <label for="amount">Amount to Transfer</label>
                <currency-input id="amount" v-model="tx.amount" />
            </div>
            <div class="frequency-field">
                <label>
                    <input type="radio" v-model="tx.frequency" name="frequency" value="Daily">
                    Daily
                </label>
                <label>
                    <input type="radio" v-model="tx.frequency" name="frequency" value="Weekly">
                    Weekly
                </label>
                <label>
                    <input type="radio" v-model="tx.frequency" name="frequency" value="Monthly">
                    Monthly
                </label>
            </div>
            <div class="field" v-if="tx.frequency == 'Weekly'">
                <label for="dayOfWeek">Day of the Week</label>
                <select id="dayOfWeek" v-model="tx.dayOfWeek">
                    <option value>--</option>
                    <option value="Sunday">Sunday</option>
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                </select>
            </div>
            <div class="field" v-else-if="tx.frequency == 'Monthly'">
                <label for="dayOfMonth">Day of the Month</label>
                <select id="dayOfMonth" v-model="tx.dayOfMonth">
                    <option value>--</option>
                    <option value="1">01</option>
                    <option value="2">02</option>
                    <option value="3">03</option>
                    <option value="4">04</option>
                    <option value="5">05</option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                </select>
            </div>
            <div class="transfer-accounts">
                <p>Transfer from Checking {{ activeCheckingAccount.accountNumber|last4 }}
                    to Savings {{ activeSavingsAccount.accountNumber|last4 }}
                </p>
            </div>
            <div class="field">
                <label class="indent">
                    <input type="checkbox" v-model="tx.skipBelow">
                    <span>
                        Skip transfer if checking account balance 
                        is below
                    </span>
                </label>
                <currency-input id="skipAmount" v-model="tx.skipAmount" />
            </div>
            <div class="field notify">
                <label>Notify me by</label>
                <span class="options">
                    <label><input type="checkbox" v-model="tx.textNotify"> Text</label>
                    <label><input type="checkbox" v-model="tx.emailNotify"> E-mail</label>
                </span>
            </div>
            <div class="buttons">
                <button class="bluebtn" :disabled="!changed">Save Changes</button>
            </div>
        </form>
        <savings-tips />
    </div>
</template>
<script>
import {mapState, mapGetters} from 'vuex'
import CurrencyInput from '../components/CurrencyInput'
import SavingsTips from '../components/SavingsTips'

export default {
    name: 'transfers',
    components: {CurrencyInput, SavingsTips},
    data() {
        return {
            tx: {
                amount: 0,
                frequency: '',
                dayOfWeek: '',
                dayOfMonth: '',
                skipBelow: false,
                skipAmount: '',
                textNotify: false,
                emailNotify: false,
            },
        }
    },
    computed: {
        ...mapState(['bankInfo', 'transfer']),
        ...mapGetters(['activeSavingsAccount', 'activeCheckingAccount']),
        changed() {
            // let v1 = Object.values(this.transfer)
            // let v2 = Object.values(this.tx)


            return JSON.stringify(this.transfer) != JSON.stringify(this.tx)
        },
    },
    filters: {
        last4(input) {
            let masked = input.substr(input.length - 4)
            return `XXXX${masked}`
        },
    },
    methods: {
        setupTransfers() {
            // this.transfer = this.tx
            // this.$store.dispatch('setTransfer', {
            //     amount: this.amount,
            //     frequency: this.frequency,
            // })
            this.$store.dispatch('setTransfer', Object.assign({}, this.tx))
        },
    },
    created() {
        // console.log(this.$store.state)
        if (this.transfer) {
            this.tx = Object.assign({}, this.transfer)
        }
        
    },
}
</script>
<style lang="scss">
#transfers-page {
    flex: 1 1 100%;

    display: flex;
    flex-flow: column nowrap;
    height: 100%;

    form {
        flex: 1 1 100%;
        background: white;
        padding: 24px;

        label {
            text-align: left;
        }

        .frequency-field {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            margin-bottom: 16px;

            label {
                font-size: 14px;
                font-weight: bold;
            }
        }

        .field input {
            flex: 0 1 auto;
        }
        .field input.currency-field {
            width: 35%;
        }

        .transfer-accounts {
            padding: 20px 0;
            text-align: left;
            p {
                font-weight: bold;
                line-height: 1.4;
            }
        }
        .field .options {
            flex: 1 1 auto;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
        }
        .field.notify label {
            flex-basis: 33%;
        }
        .indent {
            display: grid;
            grid-template-columns: auto 1fr;
            grid-gap: 4px;

            span {
                font-size: 14px;
                font-weight: bold;
            }
        }
        button[disabled] {
            opacity: 0.4;
        }
    }

    .savings-tips {
        background: #40D3FF;
        padding: 16px;
    
        h3 {
            font-size: 16px;
            font-weight: bold;
            text-align: left;
            margin-bottom: 13px;
        }

        p {
            font-size: 11px;
            text-align: left;
        }

    }
}
</style>
